<template>
  <div class="list-table">
    <div class="table-box">
      <el-table :data="messageList" style="width: 100%" :header-cell-style="{color:'#B4B4B4',height:'36px',border:'none',padding:0, background:'rgba(0,77,160,0.05)'}" :row-style="{height:'48px',padding:'0',background:'rgba(0,77,160,0.05)', borderRadius:'5px'} " :cell-style=" {fontSize:'14px',padding:0,border:'none',color:'#5C5C5C'}">
        <el-table-column label="消息" prop="message" />
        <el-table-column label="创建时间" prop="createdAt" width="200" />
      </el-table>
    </div>

    <div class="page">
      <el-button type="primary" :disabled="params.page_num==1" @click="handleUpPage">上一页</el-button>
      <el-button type="primary" @click="handleNextPage" :disabled="messageList.length<10">下一页</el-button>
    </div>
  </div>
</template>

<script>
import { getNoticeList } from '@/api/approval'
export default {
  data() {
    return {
      params: {
        page_num: 1,
        page_size: 10,
      },
      messageList: []
    }
  },
  mounted() {
    this.getNoticeList()
  },
  methods: {
    async getNoticeList() {
      const res = await getNoticeList(this.params)
      this.messageList = res.list
    },
    handleUpPage() {
      this.params.page_num--
      this.getNoticeList()
    },
    handleNextPage() {
      this.params.page_num++
      this.getNoticeList()
    }
  }

}
</script>

